/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridActionsCellItem, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Button, Stack, Chip, Tooltip } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import { useDispatch, useSelector } from 'react-redux';
import RoleAdd from './add';
import LoadingSkeleton from '../../utils/LoadingSkeleton';
import NoRowsOverlay from '../../utils/NoRowOverlay';
import RoleEdit from './edit';
import RoleDelete from './delete';
import RolePermAction from '../../store/actions/RolePermAction';
import CopyInput from '../../components/CopyInput';

function QuickSearchToolbar() {
  const [addOpen, setAddOpen] = useState(false);

  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3
      }}
    >
      <Stack direction="row" sx={{ ml: 'auto' }} spacing={2} className="MuiDataGrid-Search">
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim())}
          quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(', ')}
          debounceMs={800} // time before applying the new quick filter value
          variant="outlined"
          size="small"
          sx={{ pb: 0, maxWidth: '275px' }}
        />

        <Button
          className="button_primary"
          variant="contained"
          size="small"
          color="secondary"
          onClick={() => {
            setAddOpen(true);
          }}
        >
          Add Role
        </Button>
      </Stack>
      {addOpen === true ? (
        <RoleAdd openmodal={addOpen} onCloseModal={() => setAddOpen(false)} />
      ) : (
        ''
      )}
    </Box>
  );
}

export default function Roles() {
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10
  });
  const [sortInfo, setSortInfo] = React.useState({
    sortField: '',
    sort: ''
  });
  const [searchKey, setSearchKey] = React.useState('');
  const [editOpen, setEditOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [itemId, setItemId] = React.useState('');
  const [rowCountState, setRowCountState] = React.useState(0);
  const [data, setData] = React.useState([]);
  const dispatch = useDispatch();
  const { roleAllData, isLoading } = useSelector((state) => state.rolePermission); // Replace 'data' with your reducer name
  const { paginationData, sortingData, keyword } = useSelector(
    (state) => state.rolePermission.queryParams
  );

  useEffect(() => {
    dispatch(RolePermAction.updateQueryParams(paginationModel, sortInfo, searchKey));
    dispatch(RolePermAction.getAll(paginationModel, sortInfo, searchKey));
  }, [dispatch, paginationModel, sortInfo, searchKey]);

  useEffect(() => {
    if (paginationData) {
      setPaginationModel(paginationData);
    }
    if (sortingData) {
      setSortInfo(sortingData);
    }
    if (keyword) {
      setSearchKey(keyword);
    }
  }, [paginationData, keyword, sortingData]);

  useEffect(() => {
    if (roleAllData) {
      if (roleAllData.data) {
        setData(
          roleAllData.data.map((item) => {
            if (item.status === 1) {
              return { ...item, checked: true };
            }
            return { ...item, checked: false };
          })
        );
      } else {
        setData([]);
      }
      setRowCountState((prevRowCountState) =>
        roleAllData.total !== undefined ? roleAllData.total : prevRowCountState
      );
    }
  }, [roleAllData]);

  const handleSwitchOnChange = (id, status) => {
    const formData = {
      status: status === 1 ? 2 : 1
    };
    // Dispatch the action with formData
    dispatch(RolePermAction.update(id, formData));
  };

  // const handleSwitchOnChange = (e, id) => {
  //   const isChecked = e.target.checked;

  //   setData((prevData) =>
  //     prevData.map((item) => {
  //       if (item._id === id) {
  //         // Update the checked property of the matching item
  //         return { ...item, checked: isChecked };
  //       }
  //       return item; // Return the original item if the condition is not met
  //     })
  //   );

  //   // Define the formData object based on isChecked
  //   const formData = {
  //     status: isChecked ? 1 : 2
  //   };

  //   // Dispatch the action with formData
  //   dispatch(RolePermAction.update(id, formData));
  // };

  const columns = [
    {
      field: 'unique_id',
      headerName: '',
      align: 'left',
      flex: 0.3,
      renderCell: (params) => {
        if (params && params.value) {
          return <CopyInput id={params.value} />;
        }
        return null;
      }
    },
    {
      field: 'name',
      headerName: 'Role Name',
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        if (params && params.value) {
          return params.value === 1 ? (
            <Chip label="Active" color="success" />
          ) : (
            <Chip label="Inactive" color="lignhtwarning" />
          );
        }
        return null;
      }
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      flex: 1,
      getActions: (params) => [
        <Tooltip title="Edit" arrow placement="top" key={0}>
          <GridActionsCellItem
            icon={<i className="icon-edit" />}
            className="actionBtn"
            label="Delete"
            onClick={() => {
              setEditOpen(true);
              setItemId(params.id);
            }}
          />
        </Tooltip>,
        params.row.status === 1 ? (
          <Tooltip title="Inactive" arrow placement="top" key={1}>
            <GridActionsCellItem
              icon={<IndeterminateCheckBoxOutlinedIcon color="error" />}
              className="actionBtn"
              // color="primary"
              label="Toggle Admin"
              onClick={() => {
                handleSwitchOnChange(params.id, params.row.status);
              }}
              // showInMenu
            />
          </Tooltip>
        ) : (
          <Tooltip title="Acitve" arrow placement="top" key={2}>
            <GridActionsCellItem
              icon={<CheckBoxOutlinedIcon color="success" />}
              className="actionBtn"
              // color="primary"
              label="Toggle Admin"
              onClick={() => {
                handleSwitchOnChange(params.id, params.row.status);
              }}
              // showInMenu
            />
          </Tooltip>
        ),
        <Tooltip title="Delete" arrow placement="top" key={3}>
          <GridActionsCellItem
            icon={<i className="icon-delete" />}
            className="actionBtn"
            label="Delete"
            onClick={() => {
              setDeleteOpen(true);
              setItemId(params.id);
            }}
          />
        </Tooltip>
      ]
    }
  ];

  const handleSortModelChange = React.useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      const sortData = {
        sortField: field,
        sort
      };
      setSortInfo(sortData);
    }
    // else {
    //   dispatch(RolePermAction.getAll(paginationModel, sortInfo));
    // }
    // eslint-disable-next-line
  }, []);

  const onFilterChange = React.useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    const searchKeyword = filterModel.quickFilterValues[0];
    setPaginationModel({ page: 0, pageSize: 10 });
    setSearchKey(searchKeyword);
    // dispatch(RolePermAction.getAll(paginationModel, sortInfo, keyword));
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
        <DataGrid
          rows={data}
          getRowId={(row) => row._id}
          rowCount={rowCountState}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10
              }
            }
          }}
          autoHeight
          sx={{ minHeight: 650, '--DataGrid-overlayHeight': '300px' }}
          disableColumnFilter
          rowHeight={50}
          slots={{
            toolbar: QuickSearchToolbar,
            loadingOverlay: LoadingSkeleton,
            noRowsOverlay: NoRowsOverlay
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          disableRowSelectionOnClick
          loading={isLoading}
        />
      </Box>

      {editOpen === true ? (
        <RoleEdit openmodal={editOpen} itemId={itemId} onCloseModal={() => setEditOpen(false)} />
      ) : (
        ''
      )}
      {deleteOpen === true ? (
        <RoleDelete
          openmodal={deleteOpen}
          itemId={itemId}
          onCloseModal={() => setDeleteOpen(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
